import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#343A3F",
      d: "M10.591 9 15.4 4.193l.991-.992a.375.375 0 0 0 0-.53l-1.06-1.06a.375.375 0 0 0-.53 0L9 7.408l-5.799-5.8a.375.375 0 0 0-.53 0L1.61 2.672a.375.375 0 0 0 0 .53L7.41 9l-5.8 5.798a.375.375 0 0 0 0 .53l1.06 1.061a.375.375 0 0 0 .53 0L9 10.591l4.808 4.808.991.991a.375.375 0 0 0 .53 0l1.061-1.06a.375.375 0 0 0 0-.53z"
    }, null, -1)
  ]))]))
}
export default { render: render }